import axios from 'axios';
import { getConfig } from '../config';
import { btnSpin, resetButton } from '../core/cookie-manager';

export default class savePreferences {

    private url: string = '';

    constructor() {
        const config = getConfig();
        if (!config) return;
        this.url = config.rest_urls.save_preference;
    }

    /**
     * Save preference via REST API
     */
    save(btn: HTMLButtonElement, data: Record<string, any>, onSuccess?: () => void): void {
        const spin = btnSpin();

        btn?.setAttribute('disabled', '');
        btn?.append(spin);

        const datastring = new URLSearchParams(data as any).toString();
        const queryString = new URLSearchParams({ 'fields': datastring }).toString();

        axios.post(this.url, queryString)
            .then((response: any) => {
                resetButton(spin, btn);

                if (response.data.status === true && onSuccess) {
                    onSuccess();
                }
            })
            .catch(() => {
                resetButton(spin, btn);
            });
    }
}
